import type { BrandConfig } from '../brand.types'
import { skufvpn } from './skufvpn'

const domain = 'https://skufvpn.store'

/**
 * skufvpn.store — как com (тексты/терминология совпадают), но:
 *  - на главной есть SEO FAQ-блок (features.seoFaq),
 *  - своя коммерческая SEO-обвязка (metadata),
 *  - Яндекс.Метрика включена (features.metrika=true). Своего counter-id у store
 *    нет — наследуется analytics из skufvpn (metrikaId 103316589). Если нужен
 *    отдельный счётчик store, добавьте сюда override `analytics`.
 *  - бэкенд указывает на skufpro.ru (как в текущем проде — см. STUDY.md, решение владельца).
 * Копирайт/тексты переиспользуем из skufvpn.
 */
export const skufstore: BrandConfig = {
	...skufvpn,
	id: 'skufstore',
	domain,
	baseUrl: 'https://backend.skufpro.ru',
	assets: {
		...skufvpn.assets,
		metaIcon: `${domain}/metaicon.svg`,
		favicon: `${domain}/favicon.ico`,
		// Док «Инструкция по подключению (skufvpn.store)»
		instructionsDocUrl:
			'https://docs.google.com/document/d/1AMAjPD7uAUR_be5MPdWj3Xy7DPRg3xFmHOpJuTftI_M/edit?tab=t.0',
		appInstructions: {
			ios: {
				happ: 'https://docs.google.com/document/d/1b94A5LOabNjxp6BcXOdvw0Av0arhHSINKSR4VI-TCw8/edit?tab=t.0',
				streisand:
					'https://docs.google.com/document/d/19rOfN0iaWrowIIoWPcavWZZXLfAVmnUepu8xIHPzDeI/edit?tab=t.0',
				v2box:
					'https://docs.google.com/document/d/1Yl4HuXMEnOJ3BEXEq9WZ6WMmd6awv1MRk3-pp4anWfI/edit?tab=t.0#heading=h.7w3ojn5sv251',
			},
			android: {
				happ: 'https://docs.google.com/document/d/16JPGIohBU4asouvce-NyY9WL54HkXEubdp1aHlEysHs/edit?tab=t.0#heading=h.7w3ojn5sv251',
				hiddify:
					'https://docs.google.com/document/d/1LGtsasakcESJ8A7bQx9gJTxTW56ld8yGoBRFfbt5yxY/edit?tab=t.0#heading=h.7w3ojn5sv251',
			},
			macos: {
				happ: 'https://docs.google.com/document/d/11qYuHaaqByc63W_CuHIDHuT4ycqDPf_S3G-94GlwLBk/edit?tab=t.0',
				v2box:
					'https://docs.google.com/document/d/1IhjB49MzUbLezRsuQwHS0V2HM0GNbvepyTCYvgVQHXY/edit?tab=t.0#heading=h.7w3ojn5sv251',
			},
			windows: {
				hiddify:
					'https://docs.google.com/document/d/1ZdVYl1WSYC-yeTaAmuRInQQV_weIDKqg7mqz90Z-mRs/edit?tab=t.0#heading=h.7w3ojn5sv251',
			},
			linux: {
				hiddify:
					'https://docs.google.com/document/d/1Jh5frletz4Py90ufRRecyehgbTiP2v0uGynA8J_hrSo/edit?tab=t.0',
			},
		},
	},
	metadata: {
		title: 'SKUF.VPN — Быстрый VPN для России и СНГ | Доступ к заблокированным сайтам',
		description:
			'Безопасный VPN-сервис для обхода блокировок YouTube, Instagram, Telegram. Высокая скорость, без логов, пробный период 3 дня. От 199₽/мес. Работает в России и Казахстане.',
		keywords:
			'купить vpn, впн подписка, дешевый vpn, купить впн, впн купить подписку, vpn купить, vpn подписка купить, купить ключ впн, купить ключ vpn, купить аккаунт vpn, какой впн купить, купить впн на пк, купить хороший впн, wireguard vpn купить, outline vpn купить, vless vpn купить, vpn для youtube, vpn для instagram, vpn для телеграм, обход блокировок, разблокировать сайты, лучший vpn для россии, быстрый vpn, vpn без логов, vpn россия, впн казахстан, российский vpn сервис, как обойти блокировку youtube, лучший впн для россии 2025, skufvpn, скуф впн',
		siteName: 'SKUF.VPN',
	},
	features: {
		seoFaq: true,
		metrika: true,
		productionSourceMaps: true,
	},
}

export default skufstore
